import { render, staticRenderFns } from "./office-search-item.vue?vue&type=template&id=d5ed1f98&"
import script from "./office-search-item.vue?vue&type=script&lang=js&"
export * from "./office-search-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d5ed1f98', component.options)
    } else {
      api.reload('d5ed1f98', component.options)
    }
    module.hot.accept("./office-search-item.vue?vue&type=template&id=d5ed1f98&", function () {
      api.rerender('d5ed1f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/custom-apps/components/search/office-search-item.vue"
export default component.exports